import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-e1-impact",
  "use": "icon-leo-e1-impact-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-e1-impact\">\r\n<g transform=\"translate(-176.128 -176.128) scale(1.344000)\">\r\n<path d=\"M192 192h160v160H192V192zm240 0h160v160H432V192zm240 0h160v160H672V192zM192 432h160v160H192V432zm240 0h160v160H432V432zm240 0h160v160H672V432zM192 672h160v160H192V672zm240 0h160v160H432V672zm240 0h160v160H672V672z\" />\r\n  <path d=\"M352 272h80v48H352v-48zm240 0h80v48h-80v-48zM272 352v80h48v-80h-48zm240 0v80h48v-80h-48zm240 0v80h48v-80h-48zM352 512h80v48H352v-48zm240 0h80v48h-80v-48zM272 592v80h48v-80h-48zm240 0v80h48v-80h-48z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-e1-impact.svg
// module id = j9pT
// module chunks = 488